import React, {useEffect, useState} from 'react'
import _, {cloneDeep} from "lodash";
import {COLOR_LIST} from "../../../../common/constants/color.constant";
import {TrashIcon} from "@heroicons/react/24/solid";
import ClearButton from "../../../../common/ui/clear-button";
import RenderFields from "../../../../common/ui/render-fields";
import {
    COLOR_FIELD_LIST,
    COLOR_STOP_LIST,
    GRADIENT_POSITION_FIELD_LIST,
    RECTANGLE_FIELD_LIST
} from "../../../constants/design.constant";
import {
    prepareSelectedSize,
    processDisplayTextDetail,
    processTextItemsLayer,
    setSettingsToTextItems
} from "../../../utils/design-variant-util";
import {getColorHexCode, processColorDetails} from "../../../../common/utils/color-util";
import {processTextPathData} from "../../../utils/svg-data.util";
import SelectColorCodeDetails from "./select-color-code-details";
import {processBackgroundDetails} from "../../../utils/background-util";

const SelectGradientColorDetails = ({
                                        label,
                                        parentForm,
                                        colorType,
                                        colorAttribute,
                                        colorKeyAttribute,
                                        colorCodeKeyAttribute,
                                        settings,
                                        handleColorDetailsChanges,
                                        handleClearColorDetailsChanges,
                                    }) => {
    const [colorStopFieldList, setColorStopFieldList] = useState(null);

    useEffect(() => {
        prepareColorStopFieldList();
    }, [colorType])

    const prepareColorStopFieldList = () => {
        const tempColorStopFieldList = [];
        const existingParentFormDetail = {...parentForm};
        const gradientColorMap = _.keyBy(existingParentFormDetail?.gradientColorList, 'key');

        _.forEach(COLOR_STOP_LIST, colorStop => {
            const existingColorStop = gradientColorMap[colorStop?.key];
            if (!_.isEmpty(existingColorStop)) {
                tempColorStopFieldList.push(existingColorStop);
            } else {
                tempColorStopFieldList.push({...colorStop, checked: false});
            }

        });

        setColorStopFieldList(_.orderBy(tempColorStopFieldList, 'key'));
    }

    const handleClearColor = (attributeList, colorStopField) => {
        const existingColorStopFieldList = [...colorStopFieldList];
        const itemIndex = _.findIndex(existingColorStopFieldList, ['key', colorStopField.key]);

        _.forEach(attributeList, attribute => {
            existingColorStopFieldList[itemIndex][attribute] = '';
        });

        existingColorStopFieldList[itemIndex]['hexCode'] = getColorHexCode(colorStopField, colorKeyAttribute, colorCodeKeyAttribute);

        setColorStopFieldList(existingColorStopFieldList);
        prepareColorDetailsForParent(existingColorStopFieldList);
    }

    const handleFieldChanges = (event, colorStopField) => {
        const {name, value, type} = event.target;
        const existingColorStopFieldList = [...colorStopFieldList];
        const itemIndex = _.findIndex(existingColorStopFieldList, ['key', colorStopField.key]);

        if (type === 'number') {
            existingColorStopFieldList[itemIndex][name] = _.parseInt(value);
        } else if (type === 'checkbox') {
            existingColorStopFieldList[itemIndex][name] = !existingColorStopFieldList[itemIndex][name];
        } else {
            existingColorStopFieldList[itemIndex][name] = value;
        }

        existingColorStopFieldList[itemIndex]['hexCode'] = getColorHexCode(colorStopField, colorKeyAttribute, colorCodeKeyAttribute);

        setColorStopFieldList(existingColorStopFieldList);
        prepareColorDetailsForParent(existingColorStopFieldList)
    }

    const prepareColorDetailsForParent = (existingColorStopFieldList) => {
        const gradientColorList = [];
        const gradientColors = [];

        _.forEach(existingColorStopFieldList, colorStopField => {
            if (colorStopField?.checked) {
                gradientColorList.push(colorStopField);

                if (colorStopField?.hexCode) {
                    gradientColors.push(parseFloat(colorStopField?.label));
                    gradientColors.push(colorStopField?.hexCode);
                }
            }
        });

        const backgroundDetails = cloneDeep(parentForm);
        backgroundDetails.colorType = colorType;
        backgroundDetails.gradientColorList = gradientColorList;
        backgroundDetails.gradientColors = gradientColors;
        processBackgroundDetails(backgroundDetails, settings, colorKeyAttribute, colorCodeKeyAttribute);

        const event = {
            target: {
                name: colorAttribute,
                value: backgroundDetails,
                type: 'object'
            }
        };

        handleColorDetailsChanges(event);
    }

    return (
        <>

            <div className="ml-2 mt-2 field-label">
                {label}
            </div>

            <div className="justify-start mt-2">
                {colorStopFieldList?.map((colorStopField, index) => (

                    <React.Fragment key={`color-stop-${index}`}>

                        <div className="flex justify-start move-up-10">
                            <div className="field-group-container">

                                <div className="field-container mt-2 mb-2 w-20">
                                    <div className="justify-start flex">
                                        <input
                                            type="checkbox"
                                            className="h-6 w-6 mr-1"
                                            id={`color-stop-field-${index}`}
                                            name={'checked'}
                                            value={colorStopField['checked']}
                                            checked={colorStopField['checked']}
                                            onChange={(event) => {
                                                handleFieldChanges(event, colorStopField)
                                            }}>
                                        </input>
                                        <div className=''>
                                            <label className='field-label self-center ml-1'
                                                   htmlFor={`color-stop-field-${index}`}>{colorStopField?.label}</label>
                                        </div>
                                    </div>
                                </div>

                                {colorStopField['checked'] &&
                                    <div className="mt-2">
                                        <SelectColorCodeDetails
                                            parentForm={colorStopField}
                                            colorAttribute={colorAttribute}
                                            colorKeyAttribute={colorKeyAttribute}
                                            colorCodeKeyAttribute={colorCodeKeyAttribute}
                                            handleColorDetailsChanges={handleFieldChanges}
                                            handleClearColorDetailsChanges={handleClearColor}/>
                                    </div>
                                }

                            </div>
                        </div>
                    </React.Fragment>

                ))}
            </div>

            <div className="flex justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">

                    </div>

                    {/*<ClearButton handleClear={handleClearColor}/>*/}
                </div>
            </div>

        </>
    )
}

export default SelectGradientColorDetails
